export default {

    badge: "متدولوژی و امکانات آموزشی",
    title: "یک بسته آموزشی کامل؛ فراتر از یک کتاب ساده!",
    subtitle: "ما یادگیری زبان را با ۵ ابزار مکمل، به یک تجربه تعاملی، ماندگار و سرگرم‌کننده برای کودکان تبدیل کرده‌ایم.",
    missionTitle: "هدف ما: یادگیری عمیق بدون خستگی و دلزدگی",
    missionDesc: "تمام منابع با استاندارد بین‌المللی و متناسب با روان‌شناسی یادگیری کودکان ۴ تا ۱۴ سال تولید شده است.",
    ctaBtn: "مشاهده دوره‌ها و کتب",
    items: [
      {
        title: "صوت نیتیو",
        desc: "تقویت مهارت شنیداری و تلفظ صحیح با لهجه استاندارد بین‌المللی",
        icon: "bi-headphones",
        theme: "theme-coral",
      },
      {
        title: "ویدیوهای تعاملی",
        desc: "آموزش تصویری و جذاب مفاهیم با ویدیوهای کوتاه و انیمیشنی",
        icon: "bi-play-circle-fill",
        theme: "theme-cyan",
      },
      {
        title: "بازی‌های آموزشی",
        desc: "تثبیت یادگیری در قالب بازی و چالش‌های تعاملی و شاد",
        icon: "bi-controller",
        theme: "theme-yellow",
      },
      {
        title: "ورک‌شیت تمرینی",
        desc: "تقویت مهارت دست‌ورزی و نوشتاری با کاربرگ‌های استاندارد",
        icon: "bi-pencil-square",
        theme: "theme-green",
      },
      {
        title: "آزمون و خودارزیابی",
        desc: "سنجش پیشرفت گام‌به‌گام و تقویت اعتمادبه‌نفس کودک",
        icon: "bi-trophy-fill",
        theme: "theme-purple",
      },
    ],
};
